import { deepMerge, ObservableValue } from '@sensenet/client-utils';
import React, { createContext, useCallback, useEffect, useState } from 'react';
export const DEFAULT_ZOOM_LEVEL = 3;
export const defaultViewerState = {
  activePage: 1,
  showWatermark: false,
  showRedaction: true,
  showShapes: true,
  showThumbnails: false,
  zoomLevel: DEFAULT_ZOOM_LEVEL,
  rotation: undefined,
  showComments: false,
  hasChanges: false,
  isPlacingCommentMarker: false,
  activeShapePlacing: 'none',
  isCreateCommentActive: false,
  pageToGo: new ObservableValue({
    page: 1
  }),
  updateState: () => {},
  pagesRects: new Array(),
  boxPosition: {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  },
  currentlyResizedElementId: undefined
};
export const ViewerStateContext = /*#__PURE__*/createContext(defaultViewerState);
export const ViewerStateProvider = props => {
  const [state, setState] = useState(deepMerge({
    ...defaultViewerState
  }, props.options));
  useEffect(() => {
    setState(deepMerge({
      ...defaultViewerState
    }, props.options));
  }, [props.options]);
  const updateState = useCallback(callback => {
    if (callback instanceof Function) {
      setState(previous => deepMerge(previous, callback(previous)));
    } else {
      setState(previous => deepMerge(previous, callback));
    }
  }, []);
  return /*#__PURE__*/React.createElement(ViewerStateContext.Provider, {
    value: {
      ...state,
      updateState
    }
  }, props.children);
};
//# sourceMappingURL=viewer-state.js.map